export const isLocalEnvironmentUrl = () =>
  !!window &&
  ['localhost', 'localhost.troweprice.com', '127.0.0.1'].includes(
    window.location.hostname.toLowerCase()
  );

export const isDevEnvironmentUrl = () =>
  !!window && window.location.hostname.toLowerCase().startsWith('wwwdev');

export const isStageEnvironmentUrl = () =>
  !!window && window.location.hostname.toLowerCase().startsWith('wwwstage');

export const isNonProductionUrl = () =>
  isLocalEnvironmentUrl() || isDevEnvironmentUrl() || isStageEnvironmentUrl();
